<template>
  <RevDrawer :name="MODAL_NAMES.KEYBOARD" :title="i18n(translations.title)">
    <template #body>
      <ul>
        <li v-if="defaultKeyboard" class="mb-12">
          <LargePicker
            class="m-auto h-full"
            :index="-2"
            :label="defaultKeyboard.label as string"
            :loading="loading && loadingIndex === -2"
            :price="i18n.price(defaultKeyboard.price ?? '')"
            :selected="defaultKeyboard.selected"
            :sub-label="defaultKeyboard.subLabel as string"
            @click="emit('click', defaultKeyboard, -1)"
          />
        </li>
        <li
          v-if="
            selectedKeyboard &&
            defaultKeyboard?.label !== selectedKeyboard.label
          "
          class="mb-12"
        >
          <LargePicker
            class="m-auto h-full"
            :index="-1"
            :label="selectedKeyboard.label as string"
            :loading="loading && loadingIndex === -1"
            :price="i18n.price(selectedKeyboard.price ?? '')"
            :selected="selectedKeyboard.selected"
            :sub-label="selectedKeyboard.subLabel as string"
            @click="emit('click', selectedKeyboard, -1)"
          />
        </li>
        <li
          v-for="(option, index) in options"
          :key="option.label as string"
          class="mb-12 last:mb-0 md:hidden"
        >
          <LargePicker
            class="m-auto h-full"
            :index
            :label="option.label as string"
            :loading="loading && loadingIndex === index"
            :price="i18n.price(option.price ?? '')"
            :selected="option.selected"
            @click="emit('click', option, index)"
          />
        </li>
      </ul>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'

import { MODAL_NAMES } from '~/scopes/product/constants'

import type { Step } from '../../../../utils/types'
import LargePicker from '../../../LargePicker/LargePicker.vue'

import translations from './KeyboardModal.translations'

defineProps<{
  options: Step['options']
  loading: boolean
  loadingIndex: number | null
  selectedKeyboard?: Step['options'][number]
  defaultKeyboard?: Step['options'][number]
}>()

const emit = defineEmits<{
  (e: 'click', option: Step['options'][number], index: number): void
}>()

const i18n = useI18n()
</script>
